import { render, staticRenderFns } from "./HeroComponent.vue?vue&type=template&id=7b7d6234&scoped=true&"
import script from "./HeroComponent.vue?vue&type=script&lang=js&"
export * from "./HeroComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeroComponent.vue?vue&type=style&index=0&id=7b7d6234&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7d6234",
  null
  
)

export default component.exports